<template>
  <div class="Info">
    <PatientInfoSection :patientProps="patientInfoProps"/>
    <PatientStatusSection :patientProps="patientInfoProps"/>
  </div>
</template>
<script>
    import PatientInfoSection from './patientInfoSection'
    import PatientStatusSection from './patientStatusSection'

    export default {
      components: {
        PatientInfoSection, PatientStatusSection,
      },
      props: ['patientInfoProps'],
      data() {
        return {}
      },
    }
</script>
<style lang="scss">
  .Info {
    .vue-grid-layout {
      height: inherit !important;

      .gridItem {
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        align-items: stretch;
        padding: 0rem;
      }

      .vue-resizable-handle {
        padding: 0 5px 12px 0;
      }
    }
  }

</style>